import { useMapboxMapContext } from '../context/useMapboxMapContext';
import { useMapIsLoaded } from './useIsMapLoaded';

export const useMapboxLayerIds = () => {
  const { map } = useMapboxMapContext();
  const isLoaded = useMapIsLoaded();
  if (!isLoaded) return [];
  return map?.getStyle().layers?.map(layer => layer.id) ?? [];
};
